const dot = require('dot-object');
const objectPath = require("object-path");

module.exports = {
    set: function(key, value, section) {
        if (value === undefined) {
            return false;
        }

        if (window.uornorb(section)) {
            return false;
        }

        if (value === '') {
            value = null;
        }

        // no nesting
        if (!section.includes('.')) {
            let chunk = JSON.parse(window.localStorage.getItem(section));
            if (window.uorn(chunk)) {
                chunk = {};
            }
            chunk[key] = value;
            window.localStorage.setItem(section, JSON.stringify(chunk));
        } else {
            // gotta drill down via the dot
            let sectionArray = section.split('.');
            let baseSectionName = sectionArray[0];
            let chunk = JSON.parse(window.localStorage.getItem(baseSectionName));

            if (window.uorn(chunk)) {
                chunk = {};
            }

            // we dont want the original 0 position in that, as thats
            // our base section name
            sectionArray.splice(0,1);

            // use our library to add the value to the correct place in the chunk
            sectionArray.push(key);
            dot.str(sectionArray.join('.'), value, chunk);

            // resave the entire chunk
            window.localStorage.setItem(baseSectionName, JSON.stringify(chunk));
        }
    },

    setAnswer: function(key, value) {
        if (value === undefined) {
            return false;
        }

        let newKV = {
            'question': key,
            'answer': value
        };

        let a = JSON.parse(window.localStorage.getItem("answers"));

        if (a === null) {
            a = new Array();
        }

        let found = false;
        for (let i in a) {
            if (a[i].question == key) {
                a[i].answer = value;
                found = true;
                window.localStorage.setItem('answers', JSON.stringify(a));
            }
        }

        if (found === false) {
            a.push(newKV);
            window.localStorage.setItem('answers', JSON.stringify(a));
        }
    },

    // todo: load cached values - we will need to give all fields a data-id which we can push in the values of storageKey to make them selectable, bypassing the multiple-ids-per-page issue of using fieldName

    cacheQuote: function(quote) {
        this.clearQuoteCaches();
        window.localStorage.setItem('quote', JSON.stringify(quote));
    },

    cacheQuoteError: function(error) {
        this.clearQuoteCaches();
        window.localStorage.setItem('quote_error', error);
    },
    clearQuoteCaches: function() {
        window.localStorage.removeItem("quote_error");
        window.localStorage.removeItem("quote");
    },
    hasQuote: function() {
        return (JSON.parse(window.localStorage.getItem('quote')) !== null);
    },
    getQuote: function() {
        return JSON.parse(window.localStorage.getItem('quote'));
    },
    hasErrors: function() {
        return (JSON.parse(window.localStorage.getItem('quote_error')) !== null);
    },
    getErrors: function() {
        return JSON.parse(window.localStorage.getItem('quote_error'));
    },

    /**
     * Return a whole localStorage array if it exists
     *
     * @param section
     */
    getChunk: function(section) {
        if(JSON.parse(window.localStorage.getItem(section))) {
            return JSON.parse(window.localStorage.getItem(section));
        } else {
            return null;
        }
    },

    /**
     * Return an answer within a chunk from localStorage based on a given key,
     * so long as that chunk exists.
     *
     * @param key
     * @param section
     * @returns {*}
     */
    get(key, section) {
        if (window.uorn(section)) {
            section = '';
        }
        if (!section.includes('.')) {
            let chunk = this.getChunk(section);

            if (chunk && chunk[key]) {
                return chunk[key];
            } else {
                return null;
            }
        } else {
            let sectionArray = section.split('.');
            let baseSectionName = sectionArray[0];
            let chunk = JSON.parse(window.localStorage.getItem(baseSectionName));

            if (chunk === null || chunk === undefined) {
                return null;
            }

            // we dont want the original 0 position in that, as thats
            // our base section name
            sectionArray.splice(0,1);
            // use our library to add the value to the correct place in the chunk
            sectionArray.push(key);

            return dot.pick(sectionArray.join('.'), chunk);
        }
    },

    getCurrentAnswer: function(key, section) {
        if (section === undefined || section === null) {
            section = 'answers';
        }

        let a = JSON.parse(window.localStorage.getItem(section));

        let found = false;
        for (let i in a) {
            if (a[i].question === key) {
                found = a[i].answer;
            }
        }

        return (found !== false) ? found : null;
    },

    hasAnswer(key) {
        return this.hasAnswers(key);
    },

    hasAnswers(source, ...keys) {
        let allMatched = true;
        keys.map(function(key) {
            let t = this.getCurrentAnswer(key, source);
            if (t === null) {
                allMatched = false;
            }
        }, this);
        return allMatched;
    },

    getLocalStorageAddresses() {
        let addresses = this.getByPath('BaseIndividualApplication', 'addressHistories');

        if (window.uornorb(addresses)) {
            return [];
        }
        
        addresses = addresses.filter(v => {
            return (v !== undefined) && (v !== null);
        });

        return addresses;
    },

    getByPath(localStorageKey, path) {
        if (window.uornorb(path)) {
            let chunks = localStorageKey.split('.');
            path = localStorageKey.replace(String(chunks[0]) + '.', '');
            localStorageKey = chunks[0];
        }

        let item = JSON.parse(window.localStorage.getItem(localStorageKey));
        return objectPath.get(item, path);
    },

    deleteByPath(localStorageKey, path) {
        if (window.uornorb(path)) {
            let chunks = localStorageKey.split('.');
            path = localStorageKey.replace(String(chunks[0]) + '.', '');
            localStorageKey = chunks[0];
        }

        let item = JSON.parse(window.localStorage.getItem(localStorageKey));
        objectPath.del(item, path);
        window.localStorage.setItem(localStorageKey, JSON.stringify(item));
    },

    setByPath(path, value) {
        let chunks = path.split('.');
        let localStorageKey = chunks[0];
        path = path.replace(String(localStorageKey) + '.', '');

        if (value === '') {
            value = null;
        }

        let item = JSON.parse(window.localStorage.getItem(localStorageKey));
        if (window.uorn(item)) {
            window.localStorage.setItem(localStorageKey, '{}');
            item = {};
        }
        objectPath.set(item, path, value);
        window.localStorage.setItem(localStorageKey, JSON.stringify(item));
    },

    emptyByPath(path) {
        let chunks = path.split('.');
        let localStorageKey = chunks[0];
        path = path.replace(String(localStorageKey) + '.', '');

        let item = JSON.parse(window.localStorage.getItem(localStorageKey));
        objectPath.empty(item, path);

        window.localStorage.setItem(localStorageKey, JSON.stringify(item));
    },

    /**
     * modify the data in local storage for the letting referee
     * and any financial referees to set their mobile numbers to the same
     * as their "other" numbers, if;
     * - mobile is blank
     * - other phone starts with an "07"
     *
     * this function does this process for ALL referees
     * @return {Promise}
     */
    fudgeRefereeTelephoneNumbers() {
        return new Promise((resolve) => {
            // do letting referee
            let mobile = this.getByPath('BaseIndividualApplication.lettingReferee.mobile');
            let phone = this.getByPath('BaseIndividualApplication.lettingReferee.phone');
            if (!window.uornorb(mobile) || !window.uornorb(phone)) {
                if (window.uornorb(mobile) && !window.uornorb(phone) && phone.substring(0, 2) == '07') {
                    this.setByPath('BaseIndividualApplication.lettingReferee.mobile', phone);
                }
            }

            // do all the financial referees
            let financialReferees = this.getByPath('BaseIndividualApplication.financialReferees');
            if (!window.uornorb(financialReferees)) {
                financialReferees.map((ref, index) => {
                    let mobile = this.getByPath('BaseIndividualApplication.financialReferees.'+ index +'.mobile');
                    let phone = this.getByPath('BaseIndividualApplication.financialReferees.'+ index +'.phone');
                    if (window.uornorb(mobile) && !window.uornorb(phone) && phone.substring(0, 2) == '07') {
                        this.setByPath('BaseIndividualApplication.financialReferees.'+ index +'.mobile', phone);
                    }
                });
            }

            resolve (true);
        });
    },

    getDomainName() {
        let domainInfo = JSON.parse(window.localStorage.getItem('domainInfo'));
        return domainInfo.domainName;
    },
};



// WEBPACK FOOTER //
// ./src/components/Managers/Quote.js